import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 8.83L17.17 12 14 15.17V14H6v-4h8V8.83M12 4v4H4v8h8v4l8-8-8-8z"
}), 'ForwardOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ForwardOutlined.js
// module id = 3935
// module chunks = 2